module.exports = __webpack_public_path__ + "static/media/star_A.71c86bdc.png";